import React from 'react';

// Calcite
import Panel from "calcite-react/Panel";
import Popover from 'calcite-react/Popover';

// Calcite Icons
import DownloadToIcon from 'calcite-ui-icons-react/DownloadToIcon';
import MonitorIcon from 'calcite-ui-icons-react/MonitorIcon';
import WebIcon from 'calcite-ui-icons-react/WebIcon';

// components.main.Events
import { makeIcsInfo } from '../components/main/Events/ics';

// context
import Context from '../context/Context';

// util
import { addToCalendar, CALENDAR_TYPES } from './calendarUtil';

const CSS = {
  main: "i-calendar-selector",
  logo: "i-calendar-logo",
  logoGoogle: "i-calendar-logo--google",
  logoOutlook: "i-calendar-logo--outlook",
  genericButton: "i-generic-button"
};

export default class CalendarSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      icsInfo: null
    };
  }

  componentDidMount() {
    const { params } = this.props;
    const { eventICS } = params;

    if (!eventICS) {
      return;
    }
    const { info, filename } = eventICS;
    this.updateICSInfo(info, filename);
  }

  async updateICSInfo(info, filename) {
    const icsInfo = await makeIcsInfo(info, filename);
    this.setState({ icsInfo });
  }

  render() {
    const { onRequestClose, open, targetEl } = this.props;
    return (
      <Popover
        onRequestClose={onRequestClose}
        open={open}
        targetEl={targetEl}
        appendToBody
      >
        <Panel white>
          {this.renderContent()}
        </Panel>
      </Popover>
    );
  }

  renderContent() {
    const items = Object.keys(CALENDAR_TYPES).map((key) => this.renderOption(CALENDAR_TYPES[key]));

    return (
      <div className={CSS.main}>
        <ul>
          {items}
        </ul>
      </div>
    );
  }

  renderOption(type) {
    switch(type) {
      case CALENDAR_TYPES.google:
        return this.renderGoogle();
      case CALENDAR_TYPES.outlookApp:
        return this.renderOutlookApp();
      case CALENDAR_TYPES.outlookOnline:
        return this.renderOutlookOnline();
      case CALENDAR_TYPES.generic:
        return this.renderGeneric();
      default:
        return null;
    }
  }

  onClick = (event) => {
    event.stopPropagation();

    const { params, onRequestClose } = this.props;
    const type = event.target.getAttribute("data-caltype");
    if (type) {
      addToCalendar(type, params);
    }
    
    if (typeof onRequestClose === "function") {
      onRequestClose();
    }
  }

  renderGoogle() {
    const i18n = Context.getInstance().i18n;

    return (
      <li key={CALENDAR_TYPES.google}>
        <button 
          data-caltype={"google"}
          onClick={this.onClick}
        >
          <img 
            data-caltype={"google"}
            className={CSS.logoGoogle} 
            src="assets/Google.png"
            alt={i18n.general.image} 
          />
          <h3 data-caltype={"google"}>{i18n.calendars.google}</h3>
        </button>
      </li>
    );
  }

  renderOutlookApp() {
    const i18n = Context.getInstance().i18n;
    const { icsInfo } = this.state;
    if (!icsInfo) {
      return null;
    }

    return (
      <li key={CALENDAR_TYPES.outlookApp}>
        <a 
          onClick={this.onClick}
          href={icsInfo.href} 
          role="button"
          download={icsInfo.filename} 
          rel="noopener noreferrer" 
          target="_blank"
        >
          <img 
            data-caltype={"outlook-app"}
            className={CSS.logoOutlook} 
            src="assets/Outlook_64x64.svg"
            alt={i18n.general.image} 
          />
          <h3 data-caltype={"outlook-app"}>{i18n.calendars.outlookApp}</h3>
          {/* <MonitorIcon /> */}
        </a>
      </li>
    );
  }

  renderOutlookOnline() {
    const i18n = Context.getInstance().i18n;

    return (
      <li key={CALENDAR_TYPES.outlookOnline}>
        <button 
          data-caltype={"outlook-online"}
          onClick={this.onClick}
        >
          <img 
            data-caltype={"outlook-online"}
            className={CSS.logoOutlook} 
            src="assets/Outlook_64x64.svg"
            alt={i18n.general.image} 
          />
          <h3 data-caltype={"outlook-online"}>{i18n.calendars.outlookOnline}</h3>
          <WebIcon />
        </button>
      </li>
    );
  }

  renderGeneric() {
    const i18n = Context.getInstance().i18n;
    const { icsInfo } = this.state;
    if (!icsInfo) {
      return null;
    }

    return (
      <li key={CALENDAR_TYPES.generic}>
        <a 
          className={CSS.genericButton}
          onClick={this.onClick}
          href={icsInfo.href} 
          role="button"
          download={icsInfo.filename} 
          rel="noopener noreferrer" 
          target="_blank"
        >
          <DownloadToIcon data-caltype={"generic"} />
          <h3 data-caltype={"generic"}>{i18n.calendars.generic}</h3>
        </a>
      </li>
    );
  }
}